<template>
  <div class="content">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>加盟</el-breadcrumb-item>
        <el-breadcrumb-item>产品中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card style="margin-top: 20px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="商品名称"
                      prop="name">
          <el-input v-model="query.product_name_keyword"
                    placeholder="输入商品名称"
                    @input="getList(query)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="商品类型"
                      prop="ref_type">
          <el-select v-model="query.product_types"
                     clearable
                     placeholder="请选择"
                     style="width: 150px"
                     @change="getList(query)">
            <el-option v-for="item in filter.refTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="card-header">
        <TableTittle :tittle="TableName"></TableTittle>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.category_name"
                            @change="getList(query)">
              <el-radio-button v-for="(item, index) in filter.categoryName"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="tableData"
                :header-cell-style="{
          textAlign: 'center',
          color: '#909399',
          fontFamily: 'PingFang SC',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: '#F2F6FC',
        }"
                :cell-style="{ textAlign: 'center', fontSize: '13px' }"
                border>

        <el-table-column type="index"
                         label="序号"
                         width="64"></el-table-column>
        <el-table-column label="主图"
                         width="100">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px"
                      :src="scope.row.product_picture_url"
                      :preview-src-list="[scope.row.product_picture_url]"
                      fit="cover">
              <div slot="error"
                   class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="product_name"
                         label="商品名称"
                         width="320"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="product_type"
                         label="商品类型">
          <template slot-scope="scope">
            <span v-show="scope.row.product_type == '1'">课程</span>
            <span v-show="scope.row.product_type == '2'">题库</span>
            <span v-show="scope.row.product_type == '3'">专栏</span>
            <span v-show="scope.row.product_type == '4'">资料</span>
          </template>
        </el-table-column>
        <el-table-column prop="product_price"
                         label="销售价">
          <template slot-scope="scope">
            <span>
              {{ scope.row.product_price + "元" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sale_percent"
                         label="采购折扣">
          <template slot-scope="scope">
            <span>
              {{scope.row.sale_percent+"%" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="base_order_count"
                         label="起订份数">
          <template slot-scope="scope">
            <span>
              {{scope.row.base_order_count+"份" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="有效期"
                         min-width="300"
                         align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.start_time&&scope.row.end_time"> {{ scope.row.start_time | dateFormat("YYYY-MM-DD HH:mm") }} 至 {{scope.row.end_time | dateFormat("YYYY-MM-DD HH:mm")}}</span>
            <spen v-else>--</spen>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="create_time"
                         label="创建时间"
                         width="150">
          <template slot-scope="scope">
            {{ scope.row.create_time | dateFormat("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column> -->
        <el-table-column prop="create_time"
                         label="更新时间"
                         width="150">
          <template slot-scope="scope">
            {{ scope.row.update_time | dateFormat("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>

        <el-table-column prop="name"
                         label="操作"
                         width="100"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="handleToPreview(scope.row)">预览</el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="handleCreatOrder(scope.row)">下单</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 16px">
        <div class="block">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </el-card>
    <creatOrder :visible.sync="orderDialogVisible"
                :product="selectedProduct"
                @paysuccess="paysuccess" />
    <el-dialog :visible.sync="successDialogVisible"
               width="300px"
               center
               :show-close="false"
               :close-on-click-modal="false">
      <div class="dialog-content">
        <img src="../../../assets/images/success@2x.png"
             alt="下单成功图标"
             class="success-icon">
        <div class="success-title">下单成功</div>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleViewOrder"
                   type="primary"
                   plain>查看订单</el-button>
        <el-button @click="successDialogVisible=false"
                   type="primary">继续下单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { adminUrl } from '../../../utils/helper'
import TableTittle from '../../../components/TableTittle/TableTittle.vue'
import creatOrder from '../../../components/DialogComponents/warrant/creatOrder.vue'

export default {
  components: {
    TableTittle,
    creatOrder,
  },
  data() {
    return {
      TableName: '产品列表',
      submitmethods: 'add',
      filter: {
        refTypes: [
          { label: '课程', value: '1' },
          { label: '题库', value: '2' },
          { label: '专栏', value: '3' },
          { label: '资料', value: '4' },
        ],
        categoryName: [
          { label: '全部', value: '' },
          { label: '标准书课包', value: '标准书课包' },
          { label: '大学定向', value: '大学定向' },
          { label: '保研产品', value: '保研产品' },
          { label: '考研产品', value: '考研产品' },
        ],
      },
      form: {},
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        category_name: '',
      },
      pageTotal: 0,
      tableData: [],
      orderDialogVisible: false,
      selectedProduct: null,
      successDialogVisible: false,
    }
  },

  mounted() {
    this.getList(this.query)
  },
  methods: {
    paysuccess() {
      this.orderDialogVisible = false
      this.successDialogVisible = true
    },
    handleViewOrder() {
      this.successDialogVisible = false

      this.$router.push('/Warrant/orderCenter')
    },
    formatDurationToDays(seconds) {
      if (!seconds && seconds !== 0) return '-'
      const days = Math.floor(seconds / 86400)
      return `${days}天`
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getList(this.query)
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.getList(this.query)
    },

    async getList(query) {
      let str = adminUrl()
      const res = await this.$axios({
        url: `${str}/api/v1/back/crm/warrant/product/list`,
        method: 'get',
        params: query,
      })
      this.tableData = res.data.list || []
      this.pageTotal = res.data.count
    },
    handleToPreview(item) {
      const typeMap = { 1: 'course', 2: 'exam', 3: 'material', 4: 'article' }
      const path = typeMap[item.product_type]

      if (!path) return

      const isProd = location.host.includes('crm.yanshizi.com')
      const baseUrl = `${isProd ? 'https' : 'http'}://h5.${
        isProd ? 'kaoyanbox.com' : 'kaoyanbox.net'
      }`

      window.open(`${baseUrl}/${path}/detail/${item.product_id}`)
    },
    handleCreatOrder(item) {
      this.selectedProduct = item
      this.orderDialogVisible = true
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-content {
  text-align: center;
  padding: 16px 0 8px;
}

.success-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  display: inline-block;
}

.success-title {
  font-size: 18px;
  font-weight: 500;
  color: #303133;
  line-height: 1.4;
  margin-bottom: 8px;
}

.success-subtitle {
  font-size: 13px;
  color: #909399;
  line-height: 1.5;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;

  .el-button {
    min-width: 100px;
  }
}
.breadcrumb {
  display: flex;
  align-items: center;
  height: 30px;
  justify-content: space-between;
}
.card-header {
  display: flex;
  justify-content: space-between;
  .el-button {
    height: 35px;
    line-height: 10px;
  }
}
.block {
  margin-bottom: 14px;
  float: right;
}
</style>